<template>
  <!--  <v-content class="fill-height">!-->
  <v-layout wrap fluid>
    <!--    <v-flex xs12 class="title text-center">
      <span class="text-uppercase">{{$store.getters['user/name']}}</span>
      <span>{{$t('help.welcome')}}</span>
    </v-flex> !-->
    <v-flex xs12 md8 class="mb-4 pr-md-4">
      <v-card class="idcs-dialog-back">
        <v-card-title class="d-inline-block">
          <span
            class="text-uppercase"
            v-if="$store.getters['user/userinfo']"
          >{{$store.getters['user/userinfo']+','}}</span>
          <span class="ml-4 text-break">{{$t('help.welcome')}}</span>
        </v-card-title>
        <v-card-text>
          <div v-html="$t('help.intro')"></div>
          <div v-html="$t('help.func')"></div>
          <v-list-item-group>
            <template v-for="item in upperMenu">
              <v-list-item
                v-if="$store.getters.test(item.rule)"
                link
                :key="item.text"
                :to="item.route"
              >
                <v-list-item-icon>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{$t('help.menu.'+item.text)}}</v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item link to="/tickets" v-if="$store.getters.test('tickets.u') || $store.getters.test('tickets.a')">
              <v-list-item-icon>
                <v-icon>mdi-sync-alert</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{$t('help.menu.tickets')}}</v-list-item-content>
            </v-list-item>
            <v-list-item link to="/">
              <v-list-item-icon>
                <v-icon>mdi-home</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{$t('help.menu.home')}}</v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 md4>
      <v-layout wrap fluid>
        <v-flex
          xs12
          v-if="$store.getters.test('cards') || $store.getters.test('cardDets')"
          class="pb-4"
        >
          <v-card class="idcs-dialog-back">
            <v-card-subtitle>{{$t('help.home.searchByCard')}}</v-card-subtitle>
            <v-card-text>
              <v-text-field
                v-model="card"
                prepend-inner-icon="mdi-magnify"
                :label="$t('field.card')"
                :placeholder="$t('search.byCard')"
                shaped
                outlined
                clearable
                background-color="yellow lighten-4"
                class="search-card"
                :disabled="loading1"
                :loading="loading1"
                :messages="message"
                @click="searchCardByNum"
                @click:prepend-inner="searchCardByNum"
                @keyup.enter="searchCardByNum"
                @keyup.escape="card=null"
              ></v-text-field>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="$store.getters.test('cards')" class="pb-4">
          <v-card class="idcs-dialog-back">
            <v-card-subtitle>{{$t('help.home.searchByClient')}}</v-card-subtitle>
            <v-card-text>
              <v-text-field
                v-model="pattern"
                prepend-inner-icon="mdi-magnify"
                :label="$t('field.pattern')"
                :placeholder="$t('search.byPattern')"
                shaped
                clearable
                :disabled="loading1"
                outlined
                color="black"
                background-color="yellow lighten-4"
                class="search-card"
                @click="searchCardByPattern"
                @click:prepend-inner="searchCardByPattern"
                @keyup.enter="searchCardByPattern"
                @keyup.escape="cardNum=null"
              ></v-text-field>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="$store.getters.test('trans')">
          <v-card class="idcs-dialog-back">
            <v-card-subtitle>{{$t('help.home.searchByTrans')}}</v-card-subtitle>
            <v-card-text>
              <div class="align-baseline">
                <DatePicker
                  clearable
                  :label="$t('field.created')"
                  v-model="trans.date"
                  input-class="idcs-data-pick"
                  :lang="$i18n.locale"
                  class="idcs-picker-wrap"
                ></DatePicker>
                <v-text-field
                  class="mt-4 text-right search-amount"
                  outlined
                  shaped
                  dense
                  color="black"
                  background-color="yellow lighten-4"
                  v-model="trans.amount"
                  :prefix="$store.getters.sCurrency"
                  clearable
                  :label="$t('search.amount2')"
                ></v-text-field>
              </div>
              <v-autocomplete
                v-model="trans.scomp"
                outlined
                color="black"
                shaped
                background-color="yellow lighten-4"
                clearable
                :label="$t('field.subcompany')"
                :items="$store.getters['struct/subcompanies']"
              ></v-autocomplete>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="searchActivation" :disabled="loading1" color="blue darken-1">
                <v-icon>mdi-magnify</v-icon>
                {{$t('button.search')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
  <!--</v-content>!-->
</template>
<script>
import app from "@/app.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: { DatePicker },
  data() {
    return {
      trans: {
        amount: null,
        date: new Date(),
        scomp: null
      },
      upperMenu: app.upper_menu,
      card: null,
      pattern: null,
      message: "",
      loading1: false,
      loading2: false
    };
  },
  async mounted() {
    if (!this.$store.getters["struct/isLoaded"]) {
      await this.$store.dispatch("struct/LOAD_STRUCT");
    }
    /*if (this.$store.getters["admin/errors"].length == 0) {
      this.$store.dispatch("admin/LOAD_ERROR");
    }*/
  },
  methods: {
    searchActivation() {
      let q = {};
      if (this.trans.amount) q.a2 = this.trans.amount;
      if (this.trans.date) q.dt = this.trans.date.getTime();
      if (this.trans.scomp) q.sc = this.trans.scomp;
      this.$router.push({
        name: "trans",
        query: q
      });
    },
    searchCardByPattern() {
      if (this.pattern == null) return;
      if (!this.$store.getters.test("cards")) return;
      this.$router.push({
        name: "cards",
        query: { pattern: this.pattern }
      });
    },
    searchCardByNum() {
      if (this.card == null) return;
      this.loading1 = true;
      app
        .getCardCountByPattern(this.card)
        .then(response => {
          this.loading1 = false;
          if (response.eq_count && this.$store.getters.test("cardDets")) {
            this.$router.push({
              name: "card"+this.$store.getters.iface,
              params: { id: this.card }
            });
          } else if (response.like_count && this.$store.getters.test("cards")) {
            this.$router.push({
              name: "cards",
              query: { pattern: this.card }
            });
          } else {
            this.message = this.$t("label.not_found");
          }
        })
        .catch(error => {
          alert(JSON.stringify(error));
        });
    }
  }
};
</script>
<style scoped>
.search-card {
  width: 350px;
  display: inline-flex;
}
.search-amount {
  width: 250px;
  display: inline-block;
}
</style>